import React from 'react';

import { Icon, IconProps, Input, InputProps, Pressable } from '@rbilabs/universal-components';
import { Platform, StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { ZIndex, getDesignToken, layout, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const StyledAddressInput = Input.withConfig<{
  inputCustomProps?: InputProps;
  name?: string;
}>(({ inputCustomProps = {} }) => ({
  fontSize: 'md',
  width: 'full',
  minHeight: '$12',
  color: inputCustomProps?.isDisabled
    ? getDesignToken('text-disabled')
    : getDesignToken('text-default'),
  backgroundColor: inputCustomProps?.isDisabled ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
  borderColor: getDesignToken('border-color-input-default'),
  borderWidth: 1,
  isDisabled: inputCustomProps?.isDisabled,
  ...inputCustomProps,
}));

export const StyledInputIcon = Icon.withConfig<{ rightIconCustomProps?: IconProps }>(
  ({ rightIconCustomProps }) =>
    rightIconCustomProps
      ? rightIconCustomProps
      : {
          marginRight: '$4',
          color: getDesignToken('icon-form-input-default'),
        }
);

export const OptionsListWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.optionsListWrapper, style] });

export const StyledOptionsListItem = Pressable.withConfig(
  ({ isHighlighted }: { isHighlighted?: boolean }) => ({
    paddingY: '$3',
    paddingX: '$4',
    borderWidth: 1,
    width: 'full',
    borderColor: getDesignToken('border-color-default'),
    backgroundColor: getDesignToken('background-input'),
    _pressed: {
      backgroundColor: getDesignToken('background-default'),
    },
    _hover: {
      backgroundColor: getDesignToken('background-default'),
    },
    _web: {
      cursor: 'pointer',
      justifyContent: 'center',
    },
    ...(isHighlighted && {
      backgroundColor: getDesignToken('background-default'),
    }),
  })
);

const styles = StyleSheet.create({
  container: {
    zIndex: ZIndex.TOP,
  },
  optionsListWrapper: {
    elevation: Platform.OS === 'android' ? ZIndex.TOP : 2,
    marginTop: spacing.$12,
    position: 'absolute',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    width: layout.full,
    zIndex: ZIndex.TOP,
  },
});
